<template>
  <div>
    <div v-if="mostrar" class="modal fade show d-block" tabindex="-1" @click.self="cerrarModal">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content border-0 shadow-lg">

          <!-- Header -->
          <div class="modal-header bg-primary text-white py-2 px-4">
            <div class="d-flex align-items-center gap-3">
              <span class="material-symbols-outlined" style="font-size:20px">description</span>
              <div class="d-flex align-items-center gap-3">
                <h6 class="mb-0 fw-bold">Trámite: {{ planilla.idTramite }}</h6>
                <span class="text-white-50">|</span>
                <h6 class="mb-0 fw-bold">Planilla: {{ planilla.numero }}</h6>
              </div>
            </div>
            <button type="button" class="btn-close btn-close-white" @click="cerrarModal" />
          </div>

          <!-- Body -->
          <div class="modal-body p-4">

            <!-- Loading -->
            <div v-if="cargando" class="text-center py-5">
              <div class="spinner-border text-primary mb-3" role="status"></div>
              <p class="text-muted">Cargando datos de la planilla...</p>
            </div>

            <template v-else-if="planilla">

              <!-- Paciente + Fechas -->
              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-label">
                      <span class="material-symbols-outlined" style="font-size:15px">person</span>
                      Paciente
                    </div>
                    <div class="fw-bold fs-6">{{ planilla.nombre }}</div>
                    <div class="text-muted small">Cédula: {{ planilla.cedula }}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="info-card">
                    <div class="info-card-label">
                      <span class="material-symbols-outlined" style="font-size:15px">calendar_today</span>
                      Desde
                    </div>
                    <div class="fw-semibold">{{ getFormattedDate(planilla.fechaDesde) }}</div>
                    <div class="text-muted small">{{ planilla.horaDesde }}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="info-card">
                    <div class="info-card-label">
                      <span class="material-symbols-outlined" style="font-size:15px">event</span>
                      Hasta
                    </div>
                    <div class="fw-semibold">{{ getFormattedDate(planilla.fechaHasta) }}</div>
                    <div class="text-muted small">{{ planilla.horaHasta }}</div>
                  </div>
                </div>
              </div>

              <!-- Diagnósticos -->
              <div class="mb-4">
                <div class="seccion-titulo">
                  <span class="material-symbols-outlined" style="font-size:16px">medical_information</span>
                  Diagnósticos
                </div>
                <div class="diag-lista">
<div
  v-for="diag in diagnosticosVisibles"
  :key="diag.numero"
  class="diag-item"
>
  <span class="diag-badge">{{ diag.numero }}</span>
  <span class="diag-codigo">{{ diag.codigo }}</span>
  <span class="diag-nombre">{{ diag.nombre }}</span>
</div>
                  <div v-if="sinDiagnosticos" class="text-muted small fst-italic ps-1">
                    Sin diagnósticos registrados
                  </div>
                </div>
              </div>

              <!-- Tabla de detalles -->
<div class="d-flex align-items-center justify-content-between mb-2">
  <div class="seccion-titulo mb-0">
    <span class="material-symbols-outlined" style="font-size:16px">list_alt</span>
    Detalle de prestaciones
  </div>
  <button 
    class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
    @click="mostrarDetalle = !mostrarDetalle"
  >
    <span class="material-symbols-outlined" style="font-size:16px">
      {{ mostrarDetalle ? 'expand_less' : 'expand_more' }}
    </span>
    {{ mostrarDetalle ? 'Colapsar' : 'Expandir' }}
  </button>
</div>

<div v-show="mostrarDetalle">
  <div v-if="detalles.length > 0" class="table-responsive">
                <table class="table table-sm table-hover tabla-det">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descripción</th>
                      <th class="text-end">Cant.</th>
                      <th class="text-end">V. Unitario</th>
                      <th class="text-end">V. Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="det in detalles" :key="det.idPlanillaDet">
                      <td class="font-mono text-muted small">{{ det.elementoCodigo }}</td>
                      <td>{{ det.elementoNombre }}</td>
                      <td class="text-end">{{ det.cantidad }}</td>
                      <td class="text-end">{{ fmt(det.valorUni) }}</td>
                      <td class="text-end fw-semibold">{{ fmt(det.cantidad * det.valorUni) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-primary">
                      <td colspan="4" class="text-end fw-bold">Total general:</td>
                      <td class="text-end fw-bold">{{ fmt(totalGeneral) }}</td>
                    </tr>
                  </tfoot>
                </table>
  </div>
  <div v-else class="text-muted small fst-italic ps-1">
    Sin prestaciones registradas
  </div>
</div>

            </template>

            <div v-else class="text-center py-4 text-muted">
              No se encontraron datos para esta planilla.
            </div>
			
   <div v-if="!cargando && planilla" class="mt-4">
    <div class="seccion-titulo mb-2">
      <span class="material-symbols-outlined" style="font-size:16px">attach_file</span>
      Archivos
    </div>
    <ArchivoPla 
      :p_idTramite="Number(planilla.idTramite)" 
      :p_idPlanilla="Number(planilla.idPlanilla)"
    />
  </div>		
          </div>

          <!-- Footer -->
          <div class="modal-footer py-2 px-4">
            <button class="btn btn-outline-secondary btn-sm" @click="cerrarModal">
              <span class="material-symbols-outlined align-middle" style="font-size:16px">close</span>
              Cerrar
            </button>
          </div>

        </div>
      </div>
    </div>
    <div v-if="mostrar" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import api        from '@/services/api';
import dateFormat from '@/modules/dateFormat.js';
import ArchivoPla from "@/views/forms/ArchivoPla.vue";

export default {
  name: 'PlanillaModal',
  emits: ['cerrar'],
  props: {
    idPlanilla: { type: Number, default: null },
  },
  components: {
    ArchivoPla,
  },
  data() {
    return {
      planilla: null,
      detalles: [],
      mostrar:  false,
      cargando: false,
      mostrarDetalle: true,
    };
  },
  watch: {
    idPlanilla(newVal) {
      if (newVal) {
        this.mostrar = true;
        this.cargarDatos(newVal);
      }
    },
  },
  computed: {
    totalGeneral() {
      return this.detalles.reduce(
        (acc, d) => acc + d.cantidad * d.valorUni, 0
      );
    },
    sinDiagnosticos() {
      return ![1,2,3,4,5].some(n => this.planilla?.['diag' + n]);
    },
diagnosticosVisibles() {
  if (!this.planilla) return [];

  return [1, 2, 3, 4, 5]
    .map(n => ({
      numero: n,
      codigo: this.planilla['diag' + n],
      nombre: this.planilla[`diagnostico0${n}`],
    }))
    .filter(diag => diag.codigo);
},
  },
  methods: {
    fmt(value) {
      return Number(value ?? 0).toLocaleString('es-EC', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    async cargarDatos(idPlanilla) {
      this.cargando = true;
      this.planilla = null;
      this.detalles = [];
      try {
        const [planillaResp, detallesResp] = await Promise.all([
          api.get(`/vwplanillas/${idPlanilla}`),
          api.get(`/vwplanilladets/idplanilla/${idPlanilla}`),
        ]);
        this.planilla = planillaResp.data;
        this.detalles = Array.isArray(detallesResp.data) ? detallesResp.data : [];

        // Diagnósticos en paralelo
        const claves = ['diag1','diag2','diag3','diag4','diag5'];
        await Promise.all(
          claves.map(async (clave, i) => {
            const codigo = this.planilla[clave];
            const key    = `diagnostico0${i + 1}`;
            this.planilla[key] = codigo
              ? await this.obtenerNombreDiagnostico(codigo)
              : '';
          })
        );
      } catch (error) {
        console.error('Error al cargar datos de la planilla:', error);
      } finally {
        this.cargando = false;
      }
    },
    async obtenerNombreDiagnostico(codigo) {
      try {
        const resp = await api.get(`/vwdiagnosticos/codigo-sin-punto/${codigo}`);
        const data = resp.data;
        if (Array.isArray(data) && data.length > 0) return data[0].nombre;
        if (data?.nombre) return data.nombre;
        return 'No encontrado';
      } catch {
        return 'No encontrado';
      }
    },
    cerrarModal() {
      this.mostrar  = false;
      this.planilla = null;
      this.detalles = [];
      this.$emit('cerrar');
    },
  },
};
</script>

<style scoped>
/* Info cards superiores */
.info-card {
  background: #f8f9fa;
  border: 0.5px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 14px;
  height: 100%;
}
.info-card-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #6c757d;
  margin-bottom: 4px;
}

/* Sección títulos */
.seccion-titulo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #495057;
  border-left: 3px solid #0d6efd;
  padding-left: 8px;
  margin-bottom: 10px;
}

/* Diagnósticos */
.diag-lista  { display: flex; flex-direction: column; gap: 5px; }
.diag-item   { display: flex; align-items: center; gap: 10px; padding: 5px 8px; background: #f8f9fa; border-radius: 6px; font-size: 13px; }
.diag-badge  { display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; background: #0d6efd; color: #fff; border-radius: 50%; font-size: 11px; font-weight: 700; flex-shrink: 0; }
.diag-codigo { font-family: 'Courier New', monospace; color: #495057; min-width: 50px; font-weight: 600; }
.diag-nombre { color: #343a40; }

/* Tabla */
.tabla-det thead th { font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .03em; color: #495057; background: #f1f3f5; border-bottom: 2px solid #dee2e6; }
.tabla-det tbody td { font-size: 13px; vertical-align: middle; }
.font-mono { font-family: 'Courier New', monospace; }
</style>